import { render, staticRenderFns } from "./Tablero.vue?vue&type=template&id=09529396&scoped=true"
import script from "./Tablero.vue?vue&type=script&lang=js"
export * from "./Tablero.vue?vue&type=script&lang=js"
import style0 from "./Tablero.vue?vue&type=style&index=0&id=09529396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09529396",
  null
  
)

export default component.exports